import { Dayjs } from "dayjs"
import { IPsrCustomerService, IPsrExtraData } from "../psr.types"

export class PsrCustomerService implements IPsrCustomerService {
  id: number
  startDate: Dayjs
  label: string
  availableNow: boolean
  alwaysOn: boolean
  endDate?: Dayjs
  extraData?: Array<IPsrExtraData>

  constructor(
    id: number,
    startDate: Dayjs,
    label: string,
    availableNow: boolean,
    alwaysOn: boolean,
    endDate?: Dayjs,
    extraData?: Array<IPsrExtraData>,
  ) {
    this.id = id
    this.startDate = startDate
    this.endDate = endDate
    this.label = label
    this.availableNow = availableNow
    this.alwaysOn = alwaysOn
    this.extraData = extraData
  }
}
